import React from 'react'

const AzimEmoji3Svg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.8 12.8'
    >
      <g id='emoji-smile-wink-svgrepo-com' transform='translate(-4.6 -4.6)'>
        <path
          id='Path_3146'
          data-name='Path 3146'
          d='M9,14a3.019,3.019,0,0,0,.864,1.219,3.336,3.336,0,0,0,4.252.031A3.025,3.025,0,0,0,15,14.044'
          transform='translate(-1 -1.5)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3147'
          data-name='Path 3147'
          d='M17,11a6,6,0,1,1-1.757-4.243A6,6,0,0,1,17,11Z'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='0.8'
          fillRule='evenodd'
        />
        <path
          id='Path_3148'
          data-name='Path 3148'
          d='M9,11V10'
          transform='translate(-0.571 -0.769)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
        <path
          id='Path_3149'
          data-name='Path 3149'
          d='M13,10.174a1.093,1.093,0,0,0,2,0'
          transform='translate(-1.333 -0.775)'
          fill='none'
          stroke='#e15226'
          strokeLinecap='round'
          strokeWidth='0.8'
        />
      </g>
    </svg>
  )
}

export default AzimEmoji3Svg
